import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_ENVIRONMENT === 'production' ? process.env.REACT_APP_AXIOS_URL : process.env.REACT_APP_AXIOS_URL_DEV}`
    // baseURL: 'https://us-central1-leadadmin-1f8a3.cloudfunctions.net/'
})

export default axiosInstance